function mainAccordion() {
  /* Accordion box JS
    ---------------------------------------------------------------------*/
    $('.accordion-databox').each(function() {
        var $accordion = $(this),
            $accordionTrigger = $accordion.find('.accordion-trigger'),
            $accordionDatabox = $accordion.find('.accordion-data');
            
            // $accordionTrigger.first().addClass('open');
            // $accordionTrigger.first().parent('.expertise-areas-tabs .accordion-row').addClass('open');
            // $accordionDatabox.first().show();
            $('.our-commitment-acc').find('.accordion-trigger').first().removeClass('open');
            $('.our-commitment-acc').find('.accordion-data').first().hide();
            
            $accordionTrigger.on('click',function (e) {
                var $this = $(this);
                var $accordionData = $this.next('.accordion-data');
                if( $accordionData.is($accordionDatabox) &&  $accordionData.is(':visible') ){
                    $this.removeClass('open');
                    $this.parent('.expertise-areas-tabs .accordion-row').removeClass('open');
                    $accordionData.slideUp(400);
                    e.preventDefault();
                } else {
                    $accordionTrigger.removeClass('open');
                    $accordionTrigger.parent('.expertise-areas-tabs .accordion-row').removeClass('open');
                    $this.addClass('open');
                    $accordionDatabox.slideUp(400);
                    $accordionData.slideDown(400);
                }
            });
		});
}
module.exports = mainAccordion;